import { Colors, Icon, IconBlock } from "swing-components";

import { translate } from "~utils";

type TimesheetIconBlockProps = {
  //TODO: Update this to be required once the API is
  // updated + integrated. We anticipate this will be a required field
  // on /api/sub/me when we have the API endpoint available.
  isCurrentTimesheetComplete?: boolean;
  onClick: () => void;
};

export function TimesheetIconBlock(props: TimesheetIconBlockProps) {
  const { isCurrentTimesheetComplete, onClick } = props;

  return (
    <button onClick={onClick} css={{ backgroundColor: Colors.white200, margin: 16 }}>
      <IconBlock
        leftIcon={<Icon name="Punch Clock" color={Colors.blue500} />}
        content={translate("TIMESHEET_TITLE")}
        rightIcon={{
          icon: <Icon name="Chevron Right" color={Colors.blue500} />,
          onClick: onClick,
        }}
        {...(isCurrentTimesheetComplete === false && {
          badge: {
            status: "warning",
            text: translate("TIMESHEET_ACTION_REQUIRED_LABEL"),
          },
        })}
      />
    </button>
  );
}
